import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const { login } = useAuth();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            await login(email, password);
            navigate('/');
        } catch (err) {
            console.error("Error al iniciar sesión:", err.response?.data || err);
            setError(err.response?.data?.detail || 'Error al iniciar sesión. Verifica tus credenciales.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <main className="auth-main">
                <div className="auth-layout">
                    <div className="auth-info">
                        <h1>Ingresá tu e-mail y contraseña para iniciar sesión</h1>
                    </div>

                    <div className="auth-form-container">
                        <div className="auth-card-ml">
                            <form onSubmit={handleLogin}>
                                {error && <div className="alert alert-danger mb-3">{error}</div>}

                                <div className="mb-3">
                                    <label htmlFor="emailInput" className="form-label">E-mail</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="emailInput"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        disabled={loading}
                                        autoComplete="email"
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="passwordInput" className="form-label">Contraseña</label>
                                    <div className="input-group">
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            className="form-control"
                                            id="passwordInput"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                            disabled={loading}
                                            autoComplete="current-password"
                                        />
                                        <button
                                            className="btn btn-outline-secondary"
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            <i className={showPassword ? "bi bi-eye-slash" : "bi bi-eye"}></i>
                                        </button>
                                    </div>
                                </div>

                                <div className="d-grid gap-2 mt-4 mb-3">
                                    <button type="submit" className="btn btn-primary" disabled={loading}>
                                        {loading ? 'Ingresando...' : 'Continuar'}
                                    </button>
                                </div>
                            </form>

                            <div className="link-container">
                                <Link to="/register">Crear cuenta</Link>
                            </div>
                            <div className="text-center mt-3">
                                <Link to="/solicitar-reseteo">¿Olvidaste tu contraseña?</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default LoginPage;
